import { render } from "./EditingMediaTrailer.vue?vue&type=template&id=51c0d2c6"
import script from "./EditingMediaTrailer.vue?vue&type=script&lang=js"
export * from "./EditingMediaTrailer.vue?vue&type=script&lang=js"
script.render = render

export default script